import { createTheme, darken } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "contained", color: "primary" },
          style: {
            backgroundColor: "#F0EFF4",
            color: "#021D1E",
            "&:hover": { backgroundColor: darken("#F0EFF4", 0.2) },
          },
        },
      ],
    },
  },
  palette: {
    primary: { main: "#021D1E" },
    secondary: { main: "#3DDC97" },
    background: { paper: "#021D1E" },
    text: { primary: "#021D1E", secondary: "#F0EFF4" },
    warning: { main: "#FFE016" },
    info: { main: "#4466FF" },
    success: { main: "#51C64F" },
    error: { main: "#FF5B4C" },
  },
});
